import { useMutation } from '@tanstack/react-query';
import {
  CreateProviderWhiteIpAddressesBulkData,
  createProviderWhiteIpAddressesBulk,
} from 'config/requests/providerWhiteIpAddresses';

export function useCreateProviderWhiteIpAddressesBulk() {
  return useMutation({
    mutationFn: (data: CreateProviderWhiteIpAddressesBulkData) =>
      createProviderWhiteIpAddressesBulk(data),
  });
}
